import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Box, Button, MenuItem, Popover, Grid } from "@material-ui/core"
import { FilterList as FilterListIcon } from "@material-ui/icons"
import PopupState, { anchorRef, bindTrigger, bindMenu } from "material-ui-popup-state"
import { LocationOutlinedSelect, OutlinedSelect } from ".."
import { useQueryGroups, useQueryRoles, USER_ACCREDITATIONS_STATUS } from "../../data"
import { useAuth } from "../../services"

const useFiltersPopoverStyles = makeStyles((theme) => ({
  root: {
    width: 512,
    marginTop: theme.spacing(1),
  },
  paper: {
    width: "100%",
    maxWidth: "calc(100vw - 32px)",
  },
}))

const FiltersButton = ({
  options: { hasRoles, hasStatus, hasTrainingStatus, hasAccreditationStatus },
  filters,
  onFilterChange,
}) => {
  const filtersPopoverClasses = useFiltersPopoverStyles()
  const { data: groupsData } = useQueryGroups()
  const { data: rolesData } = useQueryRoles()
  const { hasFeature } = useAuth()

  const handleFilterChange = (type, eventOrValues) => {
    let values = eventOrValues.target?.value || eventOrValues
    if (values.includes("all")) {
      values = []
    }
    if (onFilterChange) onFilterChange(type, values)
  }

  const hasTrainingFeature = hasFeature("training")
  const hasAccreditationFeature = hasFeature("accreditation")

  return (
    <PopupState variant="popover" popupId="bulk-actions">
      {(popupState) => (
        <>
          <Button variant="contained" color="primary" {...bindTrigger(popupState)} ref={anchorRef(popupState)}>
            <FilterListIcon />
            <Box ml={1}>Filters</Box>
          </Button>
          <Popover
            {...bindMenu(popupState)}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            classes={filtersPopoverClasses}
          >
            <Box p={2}>
              <Grid container direction="row" spacing={2}>
                {hasRoles && (
                  <Grid item xs={6}>
                    <OutlinedSelect
                      label="Access levels"
                      native={false}
                      value={filters.filter((filter) => filter.type === "roles").map((filter) => filter.value)}
                      onChange={(event) => handleFilterChange("roles", event)}
                      multiple
                    >
                      {rolesData &&
                        rolesData.roles.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.friendlyName}
                          </MenuItem>
                        ))}
                    </OutlinedSelect>
                  </Grid>
                )}
                {hasStatus && (
                  <Grid item xs={6}>
                    <OutlinedSelect
                      label="Status"
                      native={false}
                      value={filters.filter((filter) => filter.type === "status").map((filter) => filter.value)}
                      onChange={(event) => handleFilterChange("status", event)}
                      multiple
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                      <MenuItem value="invited">Invited</MenuItem>
                      {/* <MenuItem value="expired">Expired</MenuItem> */}
                    </OutlinedSelect>
                  </Grid>
                )}
                <Grid item xs={6}>
                  <OutlinedSelect
                    label="Areas of work"
                    native={false}
                    value={filters.filter((filter) => filter.type === "groups").map((filter) => filter.value)}
                    onChange={(event) => handleFilterChange("groups", event)}
                    multiple
                  >
                    {groupsData &&
                      groupsData.groups.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </OutlinedSelect>
                </Grid>
                <Grid item xs={6}>
                  <LocationOutlinedSelect
                    label="Locations"
                    value={filters.filter((filter) => filter.type === "locations").map((filter) => filter.value)}
                    onChange={(event) => handleFilterChange("locations", event)}
                    onRegionChange={(event) => handleFilterChange("locations", event)}
                    multiple
                  />
                </Grid>
                {hasTrainingFeature && hasTrainingStatus && (
                  <Grid item xs={6}>
                    <OutlinedSelect
                      label="Training status"
                      native={false}
                      value={filters.filter((filter) => filter.type === "trainingStatus").map((filter) => filter.value)}
                      onChange={(event) => handleFilterChange("trainingStatus", event)}
                      multiple
                    >
                      <MenuItem value="none">No training assigned</MenuItem>
                      <MenuItem value="in_progress">Training in progress</MenuItem>
                      <MenuItem value="overdue">Training overdue</MenuItem>
                      <MenuItem value="complete">Training complete</MenuItem>
                    </OutlinedSelect>
                  </Grid>
                )}
                {hasAccreditationFeature && hasAccreditationStatus && (
                  <Grid item xs={6}>
                    <OutlinedSelect
                      label="Accreditations status"
                      native={false}
                      value={filters
                        .filter((filter) => filter.type === "accreditationStatus")
                        .map((filter) => filter.value)}
                      onChange={(event) => handleFilterChange("accreditationStatus", event)}
                      multiple
                    >
                      <MenuItem value={USER_ACCREDITATIONS_STATUS.NONE}>No accreditations assigned</MenuItem>
                      <MenuItem value={USER_ACCREDITATIONS_STATUS.AWAITING}>Awaiting user upload</MenuItem>
                      <MenuItem value={USER_ACCREDITATIONS_STATUS.WARNING}>Expiring soon</MenuItem>
                      <MenuItem value={USER_ACCREDITATIONS_STATUS.EXPIRED}>Expired</MenuItem>
                      <MenuItem value={USER_ACCREDITATIONS_STATUS.COMPLIANT}>Up to date</MenuItem>
                    </OutlinedSelect>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Popover>
        </>
      )}
    </PopupState>
  )
}

export { FiltersButton }
